<template>

    <v-container class="py-0">
        <v-row>
            <v-col>
                <v-card flat>
                    <v-card-title>
                        <v-btn
                                text
                                class="mt-12"
                                @click="addplayerdialog = true">
                            <v-icon>{{icons.plus}}</v-icon>
                        </v-btn>
                        <v-btn
                                text
                                class="mt-12"
                                :color="!showall?'success':''"
                                @click="getMyplayers">
                            Active
                        </v-btn>
                        <v-btn
                                text
                                class="mt-12"
                                :color="showall?'success':''"
                                @click="getAllMyplayers">
                            All
                        </v-btn>
                        <v-btn icon :color="!extended?'awesome':'success'" class="mt-12 ml-2"
                               @click="extended=!extended">
                            <v-icon>mdi-page-next</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>

                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                                :headers="headers"
                                :items="players"
                                :items-per-page="100"
                                :search="search"
                                :sort-by="['firstname']"
                                class="elevation-1"
                                v-if="players"
                                @click:row="selectPlayer($event)"
                                :footer-props="{
                                  itemsPerPageOptions:[-1,100,10,5]
                                }"
                        >

                            <template v-slot:item.name="{ item }">
                                {{item.firstname}} {{item.lastname}}
                            </template>
                            <template v-slot:item.profilepic="{ item }">
                                <v-avatar>
                                    <v-img :src="item.profilepic"/>
                                </v-avatar>
                            </template>
                            <template v-slot:item.active="{ item }">
                                <v-btn icon @click.stop="setActive(item)">
                                    <v-icon color="awesome" v-if="item.active===1">{{icons.checkon}}</v-icon>
                                    <v-icon v-else>{{icons.checkoff}}</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-menu
                                        :close-on-content-click="true"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                text
                                                v-bind="attrs"
                                                v-on="on"
                                        >
                                            {{item.status}}
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                                v-for="(s) in status"
                                                :key="s.value"
                                                @click="setStatus(item,s.value)"
                                        >
                                            <v-list-item-title>{{ s.name }}</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="">
                                            <v-list-item-title>Cancel</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>
                        </v-data-table>
                    </v-card-text>

                </v-card>

            </v-col>

        </v-row>

        <v-dialog
                v-model="addplayerdialog"
                max-width="400">
            <v-card>
                <v-card-title class="headline ">
                    Add Player
                </v-card-title>
                <v-card-text>

                    <v-form v-model="vvarify" ref="addplayerform" lazy-validation>

                        <v-text-field
                                label="First Name"
                                v-model="newfirstname"
                                :rules="nameRules"
                                outlined
                                required
                        ></v-text-field>

                        <v-text-field
                                label="Last Name"
                                v-model="newlastname"
                                :rules="nameRules"
                                outlined
                                required
                        ></v-text-field>

                        <v-text-field
                                label="Grad Year"
                                v-model="newgradyear"
                                :rules="gradyearRules"
                                outlined
                                :counter="4"
                                required
                        ></v-text-field>

                        <v-btn :disabled="!vvarify" outlined block @click="playerCreate" color="awesome">Add Player
                        </v-btn>

                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click.native="addplayerdialog = false, newurlname=''">Cancel</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-btn @click="setBilling()">Set</v-btn>

    </v-container>

</template>


<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'

  export default {
    name: 'ProfilesList',
    data() {
      return {
        search: '',
        extended: false,
        updated: false,
        noplayers: false,
        addplayerdialog: false,
        playerurlinfodialog: false,
        newurlname: '',
        addbtn: 0,
        addplayerable: false,
        vvarify: false,
        newfirstname: '',
        newlastname: '',
        left: 0,
        nameRules: [
          (v) => !!v || 'This is required'
        ],
        gradyearRules: [
          (v) => !!v || 'Gradyear is required',
          (v) => v.length >= 4 || 'Format - 2021'
        ],
        newgradyear: '',
        dialog: false,
        status: [
          {name: 'Active', value: 'active'},
          {name: 'Archived', value: 'archived'},
          {name: 'Deleted', value: 'deleted'}
        ],
        selectedrow: undefined,
        showall: false
      }

    },
    components: {},
    created() {
      this.players = JSON.parse(window.localStorage.getItem('myplayers')) || undefined
      this.getMyplayers()
    },
    computed: {
      ...mapState(['icons', 'org', 'myplayers']),
      headers() {
        if (!this.extended) {
          return [
            {text: 'Image', value: 'profilepic'},
            {text: 'First', value: 'firstname'},
            {text: 'Last', value: 'lastname'},
            {text: 'Grad Year', value: 'gradyear'}
          ]
        } else {
          return [
            {text: 'Image', value: 'profilepic'},
            {text: 'First', value: 'firstname'},
            {text: 'Last', value: 'lastname'},
            {text: 'Grad Year', value: 'gradyear'},
            {text: 'Public', value: 'active'},
            {text: 'Status', value: 'status'},
            {text: 'PIN', value: 'pin'}
          ]
        }
      },
      players: {
        get() {
          return this.myplayers
        },
        set(p) {
          this.setMyPlayers(p)
        }
      }
    },
    mounted() {

    },
    methods: {
      ...mapActions(['post', 'get', 'put']),
      ...mapMutations(['setMyPlayers']),
      async getMyplayers() {
        this.showall = false
        let p = await this.get({path: 'api/playerv2/active'})
        this.players = p
        window.localStorage.setItem('myplayers', JSON.stringify(p))
        this.$forceUpdate();
      },
      async getAllMyplayers() {
        this.showall = true
        let p = await this.get({path: 'api/playerv2/allv2array'})
        this.players = p
        this.$forceUpdate();
      },
      async selectPlayer(e) {
        if (this.selectedrow) return
        this.$router.push('/a4l/' + this.$store.state.sportcode + '/' + e.partkey)
      },
      async playerCreate() {
        if (this.$refs.addplayerform.validate()) {
          let data = {
            email: this.email,
            newfirstname: this.newfirstname,
            newlastname: this.newlastname,
            newgradyear: this.newgradyear,
            sportcode: this.$store.state.sportcode,
            org: this.org.partkey,
            isorg: true
          }
          let p = await this.post({path: 'api/profilesv2/create', body: data})
          this.addplayerdialog = false;
          this.getMyplayers()
        }
      },
      logout() {
        this.$store.commit({
          type: 'loggedin',
          loggedin: false
        });
        this.$store.commit({
          type: 'myplayers',
          myplayers: false
        });
        window.localStorage.setItem('a4ltoken', '');
        window.localStorage.setItem('a4luser', '');
        storage.setItem('myplayers', null).then(function () {
          return;
        });
        this.$router.push({name: 'Home'});
      },
      playerdelete() {
        let args = {
          url: this.$store.state.url + 'api/playerv2/delete',
          method: 'DELETE',
          data: {
            playerurl: '71241d94-c83c-4d61-9f0a-7c5d110c56d8'
          }
        }
        this.$store.dispatch('fetch', args)
      },
      sort() {
        let em = this;
        let p = Object.keys(this.$store.state.myplayers);

        sort(p).desc();
        console.log(p)
      },
      async setActive(event) {
        let act = (event.active === 0) ? 1 : 0
        event.active = act
        let index = this.players.findIndex(f => {
          return f.partkey === event.partkey
        })
        let data = {
          active: event.active,
          partkey: event.partkey,
          status: event.status
        }
        let response = await this.put({path: 'api/playerv2/setstatus', body: data})
        Object.assign(this.players[index], event)
      },
      async setStatus(item, status) {
        let index = this.players.findIndex(f => {
          return f.partkey === item.partkey
        })
        item.status = status
        if (status === 'archived') item.active = 0
        let response = await this.put({path: 'api/playerv2/setstatus', body: item})
        Object.assign(this.players[index], item)
        this.selectedrow = undefined
        if (status === 'archived' || status === 'deleted') {
          this.players.splice(index, 1)
        }
      },
      async setBilling(){
        await this.post({path:'api/playerv2/createbills'})
      }
    }
  }
</script>

